import { useState } from "react";
import { faqs } from "@/mocks/faqs";

export default function Faq() {
  const [open, setOpen] = useState<number[]>(faqs.map((_, i) => i));

  const toggle = (idx: number) =>
    setOpen((cur) =>
      cur.includes(idx) ? cur.filter((i) => i !== idx) : [...cur, idx],
    );

  return (
    <section
      id="faq"
      className="border-t border-background-200 bg-background-100"
    >
      <div className="mx-auto max-w-4xl scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
        <div className="text-center">
          <p className="text-xs font-semibold tracking-widest text-secondary-700">
            FAQ
          </p>
          <h2 className="mt-1 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
            关于栏目定位、化名原则、角色区分与更新机制，这里集中回答读者最常问到的几个问题。
          </p>
        </div>

        <div className="mt-8 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {faqs.map((item, idx) => {
            const isOpen = open.includes(idx);
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                >
                  <h3 className="font-display text-base font-bold text-foreground-950">
                    {item.q}
                  </h3>
                  <i
                    className={`shrink-0 text-lg text-secondary-700 transition-transform ${
                      isOpen ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700 md:px-6">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}